'use strict';

(function(){
  var module = angular.module('client.components');

  controller.$inject = ['ModalService', 'epsHelpService'];

  function controller (ModalService, epsHelpService) {
    var ctrl = this;

    ctrl.$onDestroy = function() {
      epsHelpService.reset();
    }

    ctrl.showEPSHelp = function() {
      return epsHelpService.showHelp();
    };

    ctrl.showHelp = function() {
      var config = {
        title: 'EPS Help',
        backdrop: 'static',
        template: require('../onBoarding/epsTutorials.jade'),
        eps: epsHelpService.getEps(),
        spireTutorial: function() {
          window.open('https://support.epslearning.com', '_blank');
        },
        starTutorial: function() {
          window.open('https://support.epslearning.com', '_blank');
        },
        wwTutorial: function() {
          window.open('https://support.epslearning.com', '_blank');
        }
      };

      ModalService.show(config);
    };
  }

  module.component('xpEpsHelp', {
    template: require('./epsHelp.jade'),
    controller: controller
  });

})();